import { z } from 'zod';

export const protocoloFormSchema = z
  .object({
    uid_profesional: z.string().min(1, 'Seleccioná un profesional'),
    uid_establecimiento: z.string().min(1, 'Seleccioná un establecimiento'),
    fecha_recepcion: z.date({ message: 'Fecha de recepción inválida' }).nullable(),
    fecha_protocolo: z.date({ message: 'Fecha de protocolo inválida' }).nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.fecha_recepcion && data.fecha_protocolo) {
      const recepcion = new Date(
        data.fecha_recepcion.getFullYear(),
        data.fecha_recepcion.getMonth(),
        data.fecha_recepcion.getDate()
      );
      const protocolo = new Date(
        data.fecha_protocolo.getFullYear(),
        data.fecha_protocolo.getMonth(),
        data.fecha_protocolo.getDate()
      );
      if (recepcion.getTime() > protocolo.getTime()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['fecha_protocolo'],
          message: 'La fecha de protocolo no puede ser anterior a la de recepción',
        });
      }
    }
  });

export type ProtocoloFormValues = z.infer<typeof protocoloFormSchema>;

export const protocoloEditSchema = z
  .object({
    fecha_recepcion: z.date({ message: 'Fecha de recepción inválida' }).nullable(),
    fecha_protocolo: z.date({ message: 'Fecha de protocolo inválida' }).nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.fecha_recepcion && data.fecha_protocolo) {
      const recepcion = new Date(
        data.fecha_recepcion.getFullYear(),
        data.fecha_recepcion.getMonth(),
        data.fecha_recepcion.getDate()
      );
      const protocolo = new Date(
        data.fecha_protocolo.getFullYear(),
        data.fecha_protocolo.getMonth(),
        data.fecha_protocolo.getDate()
      );
      if (recepcion.getTime() > protocolo.getTime()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['fecha_protocolo'],
          message: 'La fecha de protocolo no puede ser anterior a la de recepción',
        });
      }
    }
  });

export type ProtocoloEditValues = z.infer<typeof protocoloEditSchema>;
